import { Injectable } from '@angular/core';
import {
    HttpInterceptor,
    HttpRequest,
    HttpHandler
} from '@angular/common/http';
import { AuthService } from '../core/services/auth.service';
import { EnvironmentService } from '../core/services/environment.service';
import { CommonService } from '../services/common.service';
import swal from 'sweetalert2';
import { Router } from '@angular/router';
import { isNullOrUndefined } from 'util';

export const InterceptorSkipHeader = 'X-Skip-Interceptor';
export const SKIP_REPLACE_TOKEN = 'X-SKIP-REPLACE-TOKEN';
export const SKIP_REPLACE_TOKEN_APIS = ['Account/List-external', 'Bill/ListForComplaintBook-external','ComplaintBook/AddV2'];

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

    private tokenLifeTime: number = 50; //en minutos

    constructor(private authService: AuthService,
        private environmentService: EnvironmentService,
        private commonService: CommonService,
        public router: Router) { }

    intercept(req: HttpRequest<any>, next: HttpHandler) {

        const ARRAY_ENDPOINT = req.url.split('/').reverse();
        const urlApi = ARRAY_ENDPOINT[1] + '/' + ARRAY_ENDPOINT[0];

        let sessionComesFromIframe: any = localStorage.getItem('_fromIframe');
        let comesFromIframe: boolean = false;
        if (!isNullOrUndefined(sessionComesFromIframe)) {
            comesFromIframe = sessionComesFromIframe == 'true' ? true : false;
        }
        //console.log('comesFromIframe=>',  comesFromIframe);

        //let sessionIsStandaloneModule: any = localStorage.getItem('_isStandaloneModule') ;
        // if (!isNullOrUndefined(sessionIsStandaloneModule)) {
        //     isStandaloneModule = sessionIsStandaloneModule == 'true' ? true: false;
        // }
        let isStandaloneModule: boolean = this.authService.IsStandaloneModule();
        //console.log('isStandaloneModule=>', isStandaloneModule);

        let interceptorSkipHeader: boolean = req.headers.has(InterceptorSkipHeader);
        // console.log('interceptorSkipHeader', interceptorSkipHeader);

        //console.log('interceptorSkipHeader, comesFromIframe, isStandaloneModule', interceptorSkipHeader, comesFromIframe, isStandaloneModule);
        // if (!req.headers.has(InterceptorSkipHeader) && !comesFromIframe && !isStandaloneModule) {            
        if ((interceptorSkipHeader == true) || (comesFromIframe == true) || (isStandaloneModule == true)) {
            //console.log('No revisará Caducidad del Token 1');
        } else {
            if (!req.url.toString().includes('TemporaryAccess')) {
                console.log('Si revisará Caducidad del Token', req.url.toString());
                if (this.mustCloseSession()) {
                    console.log('Debe Cerrar Sesión');
                    //this.mensageLogout();
                } else {
                }
            }
        }


        if (req.headers.has(SKIP_REPLACE_TOKEN)
            && SKIP_REPLACE_TOKEN_APIS.includes(urlApi)) {
            return next.handle(req.clone());
        } else {
            if (req.headers.has(InterceptorSkipHeader)) {
                const headers = req.headers.delete(InterceptorSkipHeader);
                return next.handle(req.clone({ headers }));
            }
            // Get the auth token from the service.
            const authToken = this.authService.getAuthToken();

            // Clone the request and replace the original headers with
            // cloned headers, updated with the authorization.
            const authReq = req.clone({
                setHeaders: { Authorization: `Bearer ${authToken}` }
            });

            // send cloned request with header to the next handler.
            // console.log('INTERCEPTOR AuthInterceptor 2', req.url.toString());
            this.saveLastRequest();
            return next.handle(authReq);

        }


    }

    private saveLastRequest() {
        const currrentDate: Date = new Date(Date.now());
        let currentDateString = `${(currrentDate.getMonth() + 1).toString().padStart(2, '0')}/${(currrentDate.getDate()).toString().padStart(2, '0')}/${currrentDate.getFullYear().toString().padStart(4, '0')} ${currrentDate.getHours().toString().padStart(2, '0')}:${currrentDate.getMinutes().toString().padStart(2, '0')}:${currrentDate.getSeconds().toString().padStart(2, '0')}`;
        localStorage.setItem("lastRequest", currentDateString);
    }

    private mustCloseSession(): boolean {

        let flagMustCloseSession: boolean = false;

        // OBTENER FECHA ACTUAL
        const currentDate: Date = new Date(Date.now());
        const inactivityExeeded: boolean = this.InactivityTimeExceeded(currentDate);

        if (inactivityExeeded) {
            flagMustCloseSession = true;
        }

        return flagMustCloseSession;

    }

    private InactivityTimeExceeded(currentDate: Date): boolean {
        let inactivityTimeExeeded: boolean = false;

        // OBTENER EL ULTIMO REQUEST (EL ULTIMO CAMBIO QUE INDICA QUE HUBO ACTIVIDAD)
        const lastRequestDate: Date = this.getLastRequestDate();

        // CALCULAR LOS MINUTOS DE INACTIVIDAD EN EL SISTEMA
        const inactivityTemp = currentDate.getTime() - lastRequestDate.getTime();
        const inactivity = Number.parseInt(((inactivityTemp / 1000) / 60).toString());

        if (inactivity >= this.tokenLifeTime) {
            console.log('Inactividad Exedida. Minutos:', inactivity);
            inactivityTimeExeeded = true;
        }

        return inactivityTimeExeeded;

    }


    private getLastRequestDate(): Date {
        let lastRequestDate = new Date(Date.now());
        let lastRequestDateString = localStorage.getItem("lastRequest");

        if (lastRequestDateString) {
            const lrMonth: string = lastRequestDateString.substring(0, 2);
            const lrDay: string = lastRequestDateString.substring(3, 5);
            const lrYear: string = lastRequestDateString.substring(6, 10);
            const lrHour: string = lastRequestDateString.substring(11, 13);
            const lrMinute: string = lastRequestDateString.substring(14, 16);
            const lrSecond: string = lastRequestDateString.substring(17, 19);

            lastRequestDate.setFullYear(Number.parseInt(lrYear));
            lastRequestDate.setMonth(Number.parseInt(lrMonth) - 1);
            lastRequestDate.setDate(Number.parseInt(lrDay));
            lastRequestDate.setHours(Number.parseInt(lrHour));
            lastRequestDate.setMinutes(Number.parseInt(lrMinute));
            lastRequestDate.setSeconds(Number.parseInt(lrSecond));
        }

        return lastRequestDate;

    }

    private mensageLogout() {

        this.commonService.announceUnauthorized();
        swal.fire({
            title: 'Sesión terminada por Inactividad !',
            text: 'Debe iniciar sesión para ver este contenido.',
            icon: 'error',
            backdrop: '#0c0f0f'
        }).finally(() => {
            let curentRoute = this.router.url.substr(12);
            let parameter = "";
            if (curentRoute.length > 0) parameter = "?ftrlgn=" + curentRoute;
            window.location.href = this.environmentService.portalWebUrl + parameter;
        });

        this.authService.logOut();
    }

}
